import { VALID_IMAGE_FORMATS } from './constants';

const IMAGE_SIGNATURES: { mime: string; bytes: number[] }[] = [
  { mime: 'image/jpeg', bytes: [0xFF, 0xD8, 0xFF] },
  { mime: 'image/png', bytes: [0x89, 0x50, 0x4E, 0x47] },
  { mime: 'image/gif', bytes: [0x47, 0x49, 0x46, 0x38] },
];

const isSvgContent = (buffer: ArrayBuffer): boolean => {
  const text = new TextDecoder().decode(buffer).trim().toLowerCase();
  return text.startsWith('<?xml') || text.startsWith('<svg');
};

const matchesSignature = (header: Uint8Array, signature: number[]): boolean => {
  return signature.every((byte, i) => header[i] === byte);
};

export const validateImageBytes = (file: File): Promise<boolean> => {
  return new Promise((resolve) => {
    if (!VALID_IMAGE_FORMATS.includes(file.type)) {
      resolve(false);
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const buffer = reader.result as ArrayBuffer;

      if (file.type === 'image/svg+xml') {
        resolve(isSvgContent(buffer));
        return;
      }

      const header = new Uint8Array(buffer).slice(0, 8);
      const isValid = IMAGE_SIGNATURES.some((sig) => matchesSignature(header, sig.bytes));
      resolve(isValid);
    };

    reader.onerror = () => resolve(false);

    if (file.type === 'image/svg+xml') {
      reader.readAsArrayBuffer(file.slice(0, 1024));
    } else {
      reader.readAsArrayBuffer(file.slice(0, 8));
    }
  });
};